// Function to sync the height of the thumbnails column with the main image
function syncThumbnailHeight() {
    var mainImage = document.querySelector('.main-image');
    var thumbnails = document.querySelector('.thumbnails.cc-carousel__scroll-area');
    if (mainImage && thumbnails) {
      thumbnails.style.height = mainImage.offsetHeight + 'px';
    }
}

// Run on page load and window resize
document.addEventListener('DOMContentLoaded', syncThumbnailHeight);
window.addEventListener('resize', syncThumbnailHeight);

// Run every time the product slider changes slide (Slick's afterChange event)
$('.product-slideshow').on('afterChange', function(event, slick, currentSlide){
  syncThumbnailHeight();
});

// Only apply to prev/next buttons inside .product-slideshow
$('.product-slideshow .slick-prev, .product-slideshow .slick-next').on('click', function() {
  // Wait for the slide to finish changing, then update the height
  setTimeout(syncThumbnailHeight, 100);
});

document.addEventListener('DOMContentLoaded', function() {
  var stickyBtn = document.querySelector('.sticky-atc-btn');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', function(e) {
    if (window.innerWidth > 767) return;

    var variantSelect = document.querySelector('select.original-selector');
    if (!variantSelect) return;

    var variantCount = variantSelect.options.length;
    if (variantCount > 1 && variantSelect.value === '') {
      e.preventDefault();
      var variantSection = document.getElementById('variant-picker-section');
      if (variantSection) {
        variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        variantSection.classList.add('highlight-variant');
        setTimeout(function() {
          variantSection.classList.remove('highlight-variant');
        }, 1200);
      }
    }
  });
});

window.addEventListener('scroll', function() {
  const stickyBtn = document.querySelector('.sticky-atc-btn');
  const anchor = document.querySelector('.sticky-atc-anchor');
  if (!stickyBtn || !anchor) return;
  const anchorTop = anchor.getBoundingClientRect().top;
  if (anchorTop <= 0) {
    stickyBtn.classList.add('active');
  } else {
    stickyBtn.classList.remove('active');
  }
});

function initializeReadMore() {
  // Get all readmore checkboxes
  const readmoreCheckboxes = document.querySelectorAll('input[id^="readmore"]');
  
  readmoreCheckboxes.forEach((checkbox, index) => {
    // Get the corresponding readmore and readless divs
    const readmoreDiv = checkbox.nextElementSibling;
    const readlessDiv = readmoreDiv.nextElementSibling;
    
    // Initially hide the readless div
    readlessDiv.style.maxHeight = '0';
    readlessDiv.style.opacity = '0';
    readlessDiv.style.overflow = 'hidden';
    
    // Add click event listener to the checkbox
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        // Show full content, hide truncated content
        readmoreDiv.style.maxHeight = '0';
        readmoreDiv.style.opacity = '0';
        readlessDiv.style.maxHeight = (readlessDiv.scrollHeight + 50) + 'px';
        readlessDiv.style.opacity = '1';
      } else {
        // Show truncated content, hide full content
        readmoreDiv.style.maxHeight = readmoreDiv.scrollHeight + 'px';
        readmoreDiv.style.opacity = '1';
        readlessDiv.style.maxHeight = '0';
        readlessDiv.style.opacity = '0';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeReadMore();
}); 